import { defineComponent as i, computed as o } from "vue";
const f = /* @__PURE__ */ i({
  __name: "paragraph",
  props: {
    theme: { default: void 0 },
    align: { default: void 0 },
    isSizeBig: { type: Boolean, default: !1 },
    text: { default: "" },
    noMargin: { type: Boolean, default: !1 },
    customClass: { default: void 0 },
    mb: { type: Boolean, default: !1 }
  },
  setup(a) {
    const e = a, s = o(() => {
      const t = [];
      return e.theme && t.push(`text--${e.theme}`), e.align && t.push(`text--${e.align}`), !e.noMargin && !e.mb && t.push("paragraph--mb"), e.isSizeBig && t.push("paragraph--size-big"), e.mb && t.push("text--mb"), e.customClass && t.push(e.customClass), t;
    });
    return { __sfc: !0, props: e, classes: s };
  }
});
export {
  f as default
};
